import { render, staticRenderFns } from "./footerNew.vue?vue&type=template&id=113886a0&scoped=true&"
import script from "./footerNew.vue?vue&type=script&lang=js&"
export * from "./footerNew.vue?vue&type=script&lang=js&"
import style0 from "./footerNew.vue?vue&type=style&index=0&id=113886a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113886a0",
  null
  
)

export default component.exports